module.exports = __webpack_public_path__ + "static/Sogo-7d3ce97a7517a857d45e4e35f0863821.png";